export const CURRENCY = 'RM ';
export const CURRENCY_MYR = 'MYR';
export const AREA_ID_DOMESTIC = 1;
export const IDENTITY_TYPE_NRIC = '1';
export const IDENTITY_TYPE_PASSPORT = '2';
export const GENDER_MALE = 'M';
export const GENDER_FEMALE = 'F';

export const PLAN_TYPE_FAMILY = 1;
export const PLAN_TYPE_INDIVIDUAL = 2;
export const MAX_APPLICANT = 6;
export const ECHANNEL_APP_ID = 'EDP';
export const DEDUCTIBLE_FAMILY = 'family';
export const FAMILY_PROMO_YES = 'Y';
export const FAMILY_PROMO_NO = 'N';

export const TAKAFUL = 'takaful';
export const ENTITY_CODE_TAKAFUL = 'EFTB';
export const INSURANCE = 'insurance';
export const ENTITY_CODE_INSURANCE = 'ELIB';

// Plan Comparison (family view) design tokens.
// `RECOMMENDED_PLAN_CODE` is a frontend fallback used when the plan premium
// payload does not carry an `isRecommended` flag from the API — swap/remove
// this once the downstream quotation API exposes that field directly.
export const RECOMMENDED_PLAN_CODE = 'Plan 2';
export const PLAN_ACCENT_COLOR = '#02A340';
export const CHILD_OCCP = 'JUV001';
export const CLIENT_TYPE_PROPOSER = '003';
export const CLIENT_TYPE_INSURED = '002';
export const CLIENT_TYPE_PAYOR = '007';
export const TYPE_EMAIL = 'email';

export const PRODUCT_CODE_INSURANCE = 'OFMP_C';
export const PRODUCT_CODE_TAKAFUL = 'OFMP_T';

export const ENTITY_TYPE_INSURANCE = 1;
export const ENTITY_TYPE_TAKAFUL = 2;

export const PRODUCT_DOCUMENTATION_INSURANCE_EN =
  'https://etiqa.com.my/v2/health-insurance-takaful/onemedical';
export const PRODUCT_DOCUMENTATION_INSURANCE_BM =
  'https://etiqa.com.my/v2/insurans-takaful-kesihatan/onemedical-bm';
export const PRODUCT_DOCUMENTATION_TAKAFUL_EN =
  'https://www.etiqa.com.my/v2/health-insurance-takaful/onemedical-takaful';
export const PRODUCT_DOCUMENTATION_TAKAFUL_BM =
  'https://www.etiqa.com.my/v2/insurans-takaful-kesihatan/onemedical-takaful-bm';

export const I18N_LANGUAGE_EN = 'en';
export const I18N_LANGUAGE_MY = 'my';

export const EN_PREFFERED_LANG = '002';
export const MY_PREFFERED_LANG = '001';

export const MERCHANT_ID_TAKAFUL = '007700743';
export const MERCHANT_ID_INSURANCE = '007703861';
export const MERCHANT_ID_EASY_MEDIC = '007013204';

export const AGENT_CODE_INSURANCE = '8OI00003';
export const AGENT_CODE_TAKAFUL = '8OT00003';
export const AGENT_BRANCH = 'BR001';

export const COLLECTION_SOURCE = '002';

export const UNCATEGORIZED_OCCUPATION = 'Unknown';
export const BMI_Q = 'bmi';
export const HEIGHT_QUESTION = 1;
export const WEIGHT_QUESTION = 2;

export const ADDRESS_RESIDENT = 'Residential';
export const BENEFICIAL_RESIDENT = 'ResidentialBenificial';
export const ADDRESS_MAILING = 'Mailing';
export const BENEFICIAL_MAILING = 'MailingBeneficial';

export const COUNTRY_MALAYSIA = 'MYS';

export const PRE_PHONE_NUMBER = '+60';
export const MY_COUNTRY_CODE = '60';

export const SELECT_YOURSELF = 'selectYourself';
export const OCCP_WORK_INDOOR = 'BANK05';
export const SELF_ID = 1;

export const DOCUMENT_LANGUAGE_EN = 'ENG';
export const DOCUMENT_LANGUAGE_MY = 'BMY';

export const BENEFICIAL = 'beneficial';
export const CODE_OTHERS = '099';

export const UW_DECLINE = 'Declined';
export const API_SUCCESS = 'success';

export const APE_DECLINE = 'UW033';

export const MARITAL_STATUS_OTHERS = '099';

export const SOURCE_APP_NAME_INSURANCE = 'onemedicalELIB';
export const SOURCE_APP_NAME_TAKAFUL = 'onemedicalEFTB';

export const PROD = 'edp';
export const UAT_GTM = 'KMCCW2H';
export const PROD_GTM = 'PDHNZCV';

export const DEFAULT_VALUE_POT = '002';

export const ONE_MEDICAL = 'onemedical';
export const EASY_MEDIC = 'easymedic';

export const ProductLabel: {
  [productType: string]: string;
} = {
  [EASY_MEDIC]: 'EasyMedic',
  [ONE_MEDICAL]: 'OneMedical',
};

export const MAX_UPLOAD_SIZE = 1 * 1024 * 1024;
export const MAX_COMPRESSED_SIZE = 500 * 1024;
export const REQUIRED_WIDTH = 1080;
export const REQUIRED_HEIGHT = 1350;
export const REQUIRED_ASPECT_RATIO = 4 / 5;

export const MAYBANK_BANK_CODE = '001';

export const PRODUCT_PAGE_PREFIX_UAT = 'https://www-gold.etiqa.com/';
export const PRODUCT_PAGE_PREFIX_PROD = 'https://www.etiqa.com.my/';

export const FUND_OTHERS = '008';

export const ALLOWED_SPECIAL_CHAR_ADDRESS = /[^a-zA-Z0-9 ,.@()/'\u2019#&-]/g;
export const ALLOWED_SPECIAL_CHAR_OTHER_FUND = /[^a-zA-Z0-9 \-.,'()/&]/g;

// PIDM (Perbadanan Insurans Deposit Malaysia) disclosure links
// Used by the standardized PIDM clause shown on the QQ1 (quotation) and CoU (review) pages.
export const PIDM_TIPS_BROCHURE_URL =
  'https://www.etiqa.com.my/pdfs/PIDM-TIPS-Brochure.pdf';
export const PIDM_PORTAL_URL = 'https://www.pidm.gov.my';
export const PIDM_PORTAL_URL_MY = 'https://www.pidm.gov.my/my';

export const ENCRYPTION_CONFIG = {
  key: 'Ease_LifeFamily_IDNos_Secret_123',
  passphrase: 'Ease.IDNo:secret01234',
};
